/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAutotaskCompanies200ResponseCompaniesInner
 */
export interface GetAutotaskCompanies200ResponseCompaniesInner {
    /**
     * 
     */
    id: number;
    /**
     * 
     */
    name: string;
}

/**
 * Check if a given object implements the GetAutotaskCompanies200ResponseCompaniesInner interface.
 */
export function instanceOfGetAutotaskCompanies200ResponseCompaniesInner(value: object): value is GetAutotaskCompanies200ResponseCompaniesInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GetAutotaskCompanies200ResponseCompaniesInnerFromJSON(json: any): GetAutotaskCompanies200ResponseCompaniesInner {
    return GetAutotaskCompanies200ResponseCompaniesInnerFromJSONTyped(json, false);
}

export function GetAutotaskCompanies200ResponseCompaniesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAutotaskCompanies200ResponseCompaniesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function GetAutotaskCompanies200ResponseCompaniesInnerToJSON(json: any): GetAutotaskCompanies200ResponseCompaniesInner {
    return GetAutotaskCompanies200ResponseCompaniesInnerToJSONTyped(json, false);
}

export function GetAutotaskCompanies200ResponseCompaniesInnerToJSONTyped(value?: GetAutotaskCompanies200ResponseCompaniesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

